// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:44:19

export default {
  "id": "mahjong-crimes-puzzle-story",
  "slug": "mahjong-crimes-puzzle-story",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/2854f3f9a9244d76a577fab1e2349219-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/2854f3f9a9244d76a577fab1e2349219/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Mahjong Crimes - Puzzle Story",
      "description": "MYSTERIOUS FEATURES\n\nPlay 100+ Mahjong exciting levels! \nDive into Agatha Christie's stories \nUse boosters and collect tile sets\n\nPLAY MAHJONG\n\nMahjong Crimes is a puzzle game where you match tiles to find clues and solve crimes. Use power-ups to beat tricky levels and win awards!\n\nSOLVE CRIMES\n\nJoin detective Hercule Poirot on the Orient Express to solve crimes in this Mahjong game! Match tiles to investigate, defeat thugs, and untangle mysteries. Fun guaranteed!\n",
      "instructions": "Solve the puzzles by eliminating pairs of identical mahjong tiles from play. You can only select the tiles if the left and right sides are free, and if there are no other tiles on top. Wipe the entire board to finish every level. Use the mouse or touchscreen to play.",
      "genres": [
        "Mahjong & Connect"
      ],
      "tags": [
        "detective",
        "story",
        "connection"
      ]
    },
    "zh-CN": {
      "title": "麻将罪行 - 解谜故事",
      "description": "神秘特性\n\n玩100+个令人兴奋的麻将关卡！\n深入阿加莎·克里斯蒂的故事\n使用增强器和收集牌组\n\n玩麻将\n\n《麻将罪案》是一款益智游戏，通过匹配麻将牌来寻找线索并解决罪案。使用增强器击败难关，赢得奖励！\n\n解决罪案\n\n加入侦探赫尔克里·波洛，在《麻将游戏》中乘坐东方快车解决罪案！匹配麻将牌进行调查，击败歹徒，解开谜团。保证乐趣无穷！",
      "instructions": "通过消除成对的相同麻将牌来解决谜题。只能选择左右两侧都空闲且上方没有其他牌的牌。清除整个牌盘来完成每一关。使用鼠标或触摸屏进行游戏。",
      "genres": [
        "麻将 & 连接"
      ],
      "tags": [
        "侦探",
        "故事",
        "联系"
      ]
    },
    "zh-TW": {
      "title": "麻將罪行 - 震撼故事",
      "description": "神秘特色\n\n玩100+款刺激的麻将關卡！\n沉浸在亞歷山大·柯南·道爾的故事中\n使用加強器並收集圖片組合\n\n玩麻將\n\n《麻將罪案》是一款解謎遊戲，您需配對圖片來尋找線索並解決罪案。使用強化功能來征服困難關卡並獲得獎項！\n\n解決罪案\n\n加入偵探赫丘雷·波洛，在這款麻將遊戲的東方快車上解決罪案！配對圖片來進行調查，擊敗暴徒，並解開謎團。保證有趣！",
      "instructions": "解開謎題，透過消除成對相同的麻將牌來進行遊戲。您只能選擇左右兩邊都沒有其他牌的牌，並且上面沒有其他牌的情況下選擇。清除整個棋盤以完成每個關卡。使用滑鼠或觸控螢幕來遊戲。",
      "genres": [
        "麻將 & 連線"
      ],
      "tags": [
        "侦探",
        "故事",
        "連結"
      ]
    },
    "zh-HK": {
      "title": "麻將罪行 - 智謀故事",
      "description": "神秘特色\n\n玩100+款令人興奮的麻將關卡！\n深入阿嘉莎·克莉絲蒂的故事\n使用強化劑並收集牌組\n\n玩麻將\n\n麻將罪行是一款拼圖遊戲，您需匹配牌片以尋找線索並解決案件。使用強化道具來通過棘手的關卡並贏取獎項！\n\n解決案件\n\n加入偵探赫拉克勒斯·波洛，在這款麻將遊戲中於東方快車上解決案件！匹配牌片以調查、擊敗惡棍並解開謎團。保證好玩！",
      "instructions": "解開謎題，通過消除成對的相同麻將牌。您只能選擇左右兩邊都沒有其他牌的牌，並且上方沒有其他牌的情況下選擇。消去整個牌盤以完成每個關卡。使用滑鼠或觸控屏遊玩。",
      "genres": [
        "麻將 & 連線"
      ],
      "tags": [
        "偵探",
        "故事",
        "關連"
      ]
    },
    "ja": {
      "title": "麻雀犯罪 - パズルストーリー",
      "description": "MYSTERIOUS FEATURES\n\n100以上のマージョン興味深いレベルで遊ぶ！\nアガサ・クリスティーの物語に没頭しよう\nブースターを使って、タイルセットを収集しよう\n\nPLAY MAHJONG\n\nマージョン・クライムズは、タイルを一致させて手がかりを見つけ、事件を解決するパズルゲームです。パワーアップを使って難しいレベルを突破し、賞品を獲得しよう！\n\nSOLVE CRIMES\n\nマージョンゲームで犯罪を解決するために、探偵ヘルクリア・ポアロと一緒にオーデンス・エクスプレスに乗り込み、事件を解決しよう！タイルを一致させて調査を行い、暴徒を倒し、謎を解き明かそう。楽しい時間が保証されています！",
      "instructions": "マージョン牌のペアを取り除いてパズルを解きましょう。左側と右側が空いていて、他の牌が上にない場合にのみ選択できます。全てのレベルを終えるには、ボードを全部掃除してください。マウスまたはタッチスクリーンを使用してプレイしてください。",
      "genres": [
        "麻雀＆コネクト"
      ],
      "tags": [
        "探偵",
        "物語",
        "関連"
      ]
    },
    "ko": {
      "title": "마종 케임스 - 퍼즐 스토리",
      "description": "MYSTERIOUS FEATURES\n\n100+ 마작 흥미로운 레벨을 플레이하세요! \n아가莎 크리스티의 이야기에 빠져들세요 \n부스터를 사용하고 타일 세트를 모으세요\n\n마작 플레이\n\n마작 범죄는 타일을 맞추어 증거를 찾고 범죄를 해결하는 패ズル 게임입니다. 어려운 레벨을 통과하고 상을 받기 위해 파워업을 사용하세요!\n\n범죄 해결\n\n오리엔트 익스프레스에 Hercule Poirot侦探과 함께 이 마작 게임에서 범죄를 해결하세요! 타일을 맞추어 조사하고, 강도를 물리치고, 미스터리를 풀어내세요. 즐거움이 보장됩니다!",
      "instructions": "마주치는 Mahjong 타일을 제거하여 퍼즐을 해결하세요. 타일을 선택할 수 있는 조건은 왼쪽과 오른쪽이 자유롭고, 위쪽에 다른 타일이 없는 경우입니다. 모든 레벨을 완료하기 위해 전체 보드를 지우세요. 마우스나 터치스크린으로 게임하세요.",
      "genres": [
        "마작 & 커넥트"
      ],
      "tags": [
        "탐정",
        "이야기",
        "연결"
      ]
    },
    "fr": {
      "title": "Mahjong Crimes - Histoire de Puzzle",
      "description": "CARACTÉRISTIQUES MYSTÉRIEUSES\n\nJoue à 100+ niveaux de Mahjong captivants ! Plonge dans les histoires d'Agatha Christie \nUtilise des boosters et collectionne des ensembles de tuiles\n\nJOUER AU MAHJONG\n\nMahjong Crimes est un jeu de puzzle où tu as besoin de correspondre des tuiles pour trouver des indices et résoudre des crimes. Utilise des pouvoirs spéciaux pour surmonter des niveaux délicats et gagner des récompenses !\n\nRÉSOLVER DES CRIMES\n\nRejoins le détective Hercule Poirot sur le Orient Express pour résoudre des crimes dans ce jeu de Mahjong ! Correspond des tuiles pour enquêter, battre des voyous et dénouer des mystères. Divertissement garanti !",
      "instructions": "Résolvez les puzzles en éliminant des paires de tuiles de Mahjong identiques du jeu. Vous ne pouvez sélectionner les tuiles que si les côtés gauche et droit sont libres, et s'il n'y a pas d'autres tuiles au-dessus. Effacez l'ensemble du plateau pour terminer chaque niveau. Utilisez la souris ou le tactile pour jouer.",
      "genres": [
        "Mahjong & Connect"
      ],
      "tags": [
        "détective",
        "histoire",
        "connexion"
      ]
    }
  }
};
